// frontend/admin-portal/src/components/orders/OrderFilters.jsx
import React from "react";
import { Input } from "@fiberhome/shared-ui";

export default function OrderFilters({ filters, onChange }) {
  const set = (key, value) => onChange({ ...filters, [key]: value, page: 1 });

  return (
    <div className="fh-supplier-filters">
      <Input
        placeholder="Search code, title, or customer..."
        value={filters.search || ""}
        onChange={(e) => set("search", e.target.value)}
      />
      <select
        className="fh-input"
        value={filters.kind || ""}
        onChange={(e) => set("kind", e.target.value)}
      >
        <option value="">All kinds</option>
        <option value="offer">Offers</option>
        <option value="order">Orders</option>
      </select>
      <select
        className="fh-input"
        value={filters.status || ""}
        onChange={(e) => set("status", e.target.value)}
      >
        <option value="">All statuses</option>
        <option value="draft">Draft</option>
        <option value="offer_sent">Offer sent</option>
        <option value="accepted">Accepted</option>
        <option value="rejected">Rejected</option>
        <option value="expired">Expired</option>
        <option value="fulfilled">Fulfilled</option>
        <option value="cancelled">Cancelled</option>
      </select>
      <Input
        type="date"
        value={filters.from || ""}
        onChange={(e) => set("from", e.target.value)}
      />
      <Input
        type="date"
        value={filters.to || ""}
        onChange={(e) => set("to", e.target.value)}
      />
    </div>
  );
}
